import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedDocumentsAGNotesReportService } from '@app/shared/services/shared-documents-ag-notes-report.service';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class DocumentsAGNotesReportDmePosService extends SharedDocumentsAGNotesReportService {

  constructor(
    http: HttpClient,
    shellService: ShellService) {
      super(http, shellService, ProductNames.DMEPOS);
    }

  override getInformationMessage(): string {
    return 'Please select the Product Case/Product Line(s) to generate the A&G Notes Report.';
  }
}
